module.exports = __webpack_public_path__ + "img/bookok.fd5fb4ba.png";